import Axios from 'axios'
import Store from '@/store/index'
import Router from '@/router'
import Aplicacion from '@/controlador/aplicacion'

const url_api = ()=> { return Store.state.url_api }
const token = ()=> { return Store.state.token }
const user = ()=>{ return Store.state.user }
const work_area = ()=>{return Store.state.workarea_actual }

const Categoria = {
    
    async index(json){

        Aplicacion.loading(true)

        await Axios.get(`${url_api()}index_categorias`,{'params':json,'headers':{'content-type':'application/json','Authorization':`Bearer ${token()}`}})
        .then(response=>{

            if(response.data.errores == 0){
                Store.dispatch('add_categorias_store', response.data.categorias)
                Store.dispatch('realizado')
            }

        })
        .catch(error => {
            console.log(error)
            window.location.reload()
        })
        .finally()

    },
    
    async store(json){

        Aplicacion.loading(true)

        await Axios.post(url_api()+'store_categoria',json,{'headers':{'content-type':'application/json','Authorization':`Bearer ${token()}`}})
        .then(response => {

            Aplicacion.loading(false)

            if(response.data.errores == 0){
                
                let categoria = response.data.categoria
                if(categoria.recurso == 'reto'){ Store.state.categorias_retos.push(categoria) }
                if(categoria.recurso == 'idea'){ Store.state.categorias_ideas.push(categoria) } 
                Store.dispatch('realizado')   
            }

            if(response.data.errores == 300){
                var nlocal ={
                    'run':true,
                    'tipo':'advertencia',
                    'titulo':this.state.user.email,
                    'contenido':'Se permiten hasta 20 categorias!',
                    'errores':[],
                    'tiempo':5000,
                    'cerrar':false
                }
                Store.commit('set_notificacion_local',nlocal)
            }


        })
        .catch(error => {
            console.log(error.message)
            window.location.reload()
        }).finally()

    },

    async update(json){

        Aplicacion.mini_loading(true)

        await Axios.put(`${url_api()}update_categoria`,json,{'headers':{'content-type':'application/json','Authorization':`Bearer ${token()}`}})
        .then(response => {
        
            if(response.data.errores == 0){
                Aplicacion.mini_loading(false)
                Aplicacion.notificar_realizado('Category updated')
            }

        })
        .catch(error => {
            console.log(error)
            window.location.reload()
        }).finally()
        
        
    },

    async delete(json){

        Aplicacion.mini_loading(true)

        await Axios.put(`${url_api()}delete_categoria`,json,{'headers':{'content-type':'application/json','Authorization':`Bearer ${token()}`}})
        .then(response => {
        
            if(response.data.errores == 0){
                
                if(json.recurso == 'reto'){
                    let c_retos = Store.state.categorias_retos
                    var c_retos_mod = c_retos.filter((cr)=>{ return(cr.id != json.categoria_id) })
                    Store.commit('set_categorias_retos', c_retos_mod)
                }

                if(json.recurso == 'idea'){
                    let c_ideas = Store.state.categorias_ideas
                    var c_ideas_mod = c_ideas.filter((ci)=>{ return(ci.id != json.categoria_id) })
                    Store.commit('set_categorias_ideas', c_ideas_mod)
                }

                Aplicacion.mini_loading(false)
                Aplicacion.notificar_realizado('Category deleted')
            }

        })
        .catch(error => {
            console.log(error)
            window.location.reload()
        }).finally()
    }

}

export default Categoria